import './style.css'
import * as THREE from 'three'
import * as TWEEN from '@tweenjs/tween.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { GLSLVersion, LoadingManager, MathUtils, MeshStandardMaterial, TextureLoader } from 'three'
import { FresnelShader } from 'three/examples/jsm/shaders/FresnelShader.js';
import { degToRad } from 'three/src/math/mathutils';
import { DRACOLoader } from 'three/examples/jsm/loaders/dracoloader';


THREE.Cache.enabled = true;

const loader = new THREE.FileLoader();

/*
function cacheModels(){
    for(let i=0; i<19; i++){

//load a text file and output the result to the console
loader.load(
    // resource URL
    'models/scene'+i+'.glb',

    // onLoad callback
    function ( data ) {
        // output the text to the console
        THREE.Cache.add("scene"+i,data);
    },

    // onProgress callback
    function ( xhr ) {
        //console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
    },

    // onError callback
    function ( err ) {
        console.error( 'An error happened' );
    }
);
    
    }
}
cacheModels();
*/
// Loading
let scene;

// Canvas

const canvas = document.querySelector('canvas.webgl')

// Game Variables

let poppedBubble = 0;
let bubbleCount = 0;
let progressPercentageReversed = 0;
let progressPercentage = 0;
let coin = 0;
var confetti;
var level = 1;
let totalLevel = 19;
var material = new THREE.MeshStandardMaterial();
var map;
let equippedSkin;
let unlockedSkins = [];
let shopOn = false;
let firstStart = true;
let levelFinished = false;
let language = navigator.language.substring(0, 2);
let languageCode = 0;
const language_levels = ["Level ", "Niveau ", "Livello ", "Niveau ", "Nivel ", "Nível "];
const language_shops = ["Shop", "Boutique", "Negozio", "Markt", "Tienda", "Comprar"];
const language_noThanks = ["Tap To Continue", "Appuyez Pour Continuer", "Tocca Per Continuare", "Tippen Sie, um fortzufahren", "Pulse Para Continuar", "Clique Para Continuar"];
const svgContainer = document.getElementById('svg');
const animItem = bodymovin.loadAnimation({
    wrapper: svgContainer,
    animType: 'svg',
    loop: false,
    autoplay: false,
    path: 'lf20_i6sqnxav.json'
});

const UI = document.getElementById('gameover-ui')
const sunBurst = document.getElementById('sunburst')
const progressbar = document.querySelector(".progress-bar")
const shopButton = document.getElementById("shopButton");
const perfect = document.getElementById("perfect" + languageCode);
const noThanks = document.getElementById("nothanks");

switch (language) {
    case "en":
        language = "en";
        languageCode = 0;
        console.log(language);
        break;
    case "fr":
        language = "fr";
        languageCode = 1;
        console.log(language);
        break;
    case "it":
        language = "it";
        languageCode = 2;
        console.log(language);
        break;
    case "de":
        language = "de";
        languageCode = 3;
        console.log(language);
        break;
    case "es":
        language = "es";
        languageCode = 4;
        console.log(language);
        break;
    case "pt":
        language = "pt";
        languageCode = 5;
        console.log(language);
        break;
    default:
        language = "en";
        languageCode = 0;
        console.log(language);
}

// Objects
let modelCoin;
let textureType = "texture";
let colors = [0xf40468, 0x3d0903, 0xec2606, 0xff7300, 0x83c700, 0x00b3ed, 0x5d00c1, 0x539b00, 0xbf0013, 0x00b26e, 0x002fb2];
let popitColor = 0xf40468;
let popitColor2 = 0xf40468;
let texture = [];

var models = [];

var materials = {};
materials['color'] = new THREE.MeshStandardMaterial({ color: 0xf40468 });

// Meshes index
var mesh;
var meshes = {};

// Loading Manager
var loadingManager = null;
var RESOURCES_LOADED = false;

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('./draco/gltf/');
dracoLoader.preload();

// Camera 

let camera;
let dirLight;
let hemiLight;


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true,
    antialias: true
})
renderer.setSize(window.innerWidth, window.innerHeight)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.shadowMap.enabled = true;

// create an AudioListener and add it to the camera
const listener = new THREE.AudioListener();

// create a global audio source
const popSound_0 = new THREE.Audio(listener);
const popSound_1 = new THREE.Audio(listener);
const popSound_2 = new THREE.Audio(listener);
const popSound_3 = new THREE.Audio(listener);
const popSound_4 = new THREE.Audio(listener);
const swoosh = new THREE.Audio(listener);
const win = new THREE.Audio(listener);
const back = new THREE.Audio(listener);
const click = new THREE.Audio(listener);
const confettiSound = new THREE.Audio(listener);
const button = new THREE.Audio(listener);


// load a sound and set it as the Audio object's buffer
const audioLoader = new THREE.AudioLoader();

function initSound() {

    audioLoader.load('sounds/pop0.mp3', function (buffer) {
        popSound_0.isPlaying = false;
        popSound_0.setBuffer(buffer);
        popSound_0.setLoop(false);
        popSound_0.setVolume(0.5);
    });

    audioLoader.load('sounds/pop4.mp3', function (buffer) {
        popSound_4.isPlaying = false;
        popSound_4.setBuffer(buffer);
        popSound_4.setLoop(false);
        popSound_4.setVolume(0.5);
    });

    audioLoader.load('sounds/pop3.mp3', function (buffer) {
        popSound_3.isPlaying = false;
        popSound_3.setBuffer(buffer);
        popSound_3.setLoop(false);
        popSound_3.setVolume(0.5);
    });

    audioLoader.load('sounds/pop2.mp3', function (buffer) {
        popSound_2.isPlaying = false;
        popSound_2.setBuffer(buffer);
        popSound_2.setLoop(false);
        popSound_2.setVolume(0.5);
    });

    audioLoader.load('sounds/pop1.mp3', function (buffer) {
        popSound_1.isPlaying = false;
        popSound_1.setBuffer(buffer);
        popSound_1.setLoop(false);
        popSound_1.setVolume(0.5);
    });

    audioLoader.load('sounds/swoosh.wav', function (buffer) {
        swoosh.isPlaying = false;
        swoosh.setBuffer(buffer);
        swoosh.setLoop(false);
        swoosh.setVolume(0.5);
    });

    audioLoader.load('sounds/win.wav', function (buffer) {
        win.isPlaying = false;
        win.setBuffer(buffer);
        win.setLoop(false);
        win.setVolume(0.5);
    });

    audioLoader.load('sounds/back.mp3', function (buffer) {
        back.isPlaying = false;
        back.setBuffer(buffer);
        back.setLoop(false);
        back.setVolume(0.5);
    });

    audioLoader.load('sounds/click.wav', function (buffer) {
        click.isPlaying = false;
        click.setBuffer(buffer);
        click.setLoop(false);
        click.setVolume(0.5);
    });

    audioLoader.load('sounds/confetti.wav', function (buffer) {
        confettiSound.isPlaying = false;
        confettiSound.setBuffer(buffer);
        confettiSound.setLoop(false);
        confettiSound.setVolume(0.5);
    });
}

function playSound(soundType) {
    switch (soundType) {
        case "popSound0":
            popSound_0.play();
            break;

        case "popSound1":
            popSound_1.play();

        case "popSound2":
            popSound_2.play();
            break;

        case "popSound3":
            popSound_3.play();
            break;

        case "popSound4":
            popSound_4.play();
            break;

        case "swoosh":
            swoosh.play();
            break;

        case "confetti":
            confettiSound.play();
            break;

        case "win":
            win.play();
            break;

        case "click":
            click.play();
            break;

        case "back":
            back.play();
            break;

        case "button":
            button.play();
            break;

    }


}

function preloadImages(array) {
    if (!preloadImages.list) {
        preloadImages.list = [];
    }
    var list = preloadImages.list;
    for (var i = 0; i < array.length; i++) {
        var img = new Image();
        img.onload = function () {
            var index = list.indexOf(this);
            if (index !== -1) {
                // remove image from the array once it's loaded
                // for memory consumption reasons
                //list.splice(index, 1);
            }
        }
        list.push(img);
        img.src = array[i];

    }
}

preloadImages(["./25.png", "./100c.png", "./200c.png", "./400c.png", "./800c.png", "./1600c.png", "./bar.png", "./box.png", "./box2.png", "./button.png", "./Close.png", "", "./coins.png", "./greenbar.png", "./Line.png", "./particle.png", "./perfect0.png", "./perfect1.png", "./perfect3.png", "./perfect4.png", "./perfect5.png", "./playButton.png", "./shopButton.png", "./sp1.png", "./sp2.png", "./sp3.png", "./sp4.png", "./sp5.png", "./sp6.png", "./star.png", "./sunburst.png", "./textures/texture0.png", "./textures/texture1.png", "./textures/texture2.png", "./textures/texture3.png"]);

initShop();


function startGame() {
    firstStart = false;
    initGame2();
}


//closeShopFirst();
function initGame() {


    // Create new Scene

    scene = new THREE.Scene()
    scene.add(listener);

    // Create Camera 

    camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
    camera.position.x = 0
    camera.position.y = 0.4
    camera.position.z = 1.8
    scene.add(camera)

    // Create Hemisphere Light

    hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 1);
    hemiLight.color.setHSL(0.6, 1, 0.6);
    hemiLight.groundColor.setHSL(0.095, 1, 0.75);
    hemiLight.position.set(0, 50, 0);
    scene.add(hemiLight);

    const hemiLightHelper = new THREE.HemisphereLightHelper(hemiLight, 1)
    scene.add(hemiLightHelper)


    //Create Directional Light

    dirLight = new THREE.DirectionalLight(0xFFFFFF, 1.0);
    dirLight.position.set(100, 110, 100);
    dirLight.target.position.set(0, 0, 0);
    dirLight.castShadow = true;
    dirLight.shadow.mapSize.width = 2048;
    dirLight.shadow.mapSize.height = 2048;
    scene.add(dirLight);

    // Load sounds

    initSound();

    poppedBubble = 0;
    bubbleCount = 0;
    progressPercentage = 0;
    progressPercentageReversed = 100;

    level = localStorage.getItem("level");
    if (!level) {
        level = 1;
    }


    coin = localStorage.getItem('coin');
    if (!coin) {
        coin = 0;
    }
    if (firstStart) {
        setTimeout(() => {
            startGame();
        }, 3000);
    }

}

function initGame2() {

    shopOn = false;
    levelFinished = false;

    document.body.className = "colorDefault";

    const progressbar = document.querySelector(".progress-bar")
    progressbar.setAttribute("style", "visibility: visible;");

    const progressbarcss = document.querySelector('.progress-bar')
    progressbarcss.style.marginRight = "" + progressbarcss.style.width / 2 + "px";


    const levelTxt = document.querySelector('#level')
    levelTxt.style.marginLeft = "" + levelTxt.style.width / 2 + "px";
    levelTxt.innerHTML = language_levels[languageCode] + level;

    const currentLevel = document.querySelector('#current-level')
    currentLevel.innerHTML = level;

    const nextLevel = document.querySelector('#next-level')
    nextLevel.innerHTML = Number(level) + 1;

    document.getElementById('level-progress').innerHTML = poppedBubble + " / " + bubbleCount;
    const progressBar = document.querySelector('.fillBar'); // Get progress bar element
    const style = getComputedStyle(progressBar);
    progressBar.style.clipPath = "inset(0px " + progressPercentageReversed + "% 0px 0px)"  // Set level progress bar
    document.getElementById('level-progress').innerHTML = poppedBubble + " / " + bubbleCount; // Set level progress text

    const shopButton = document.getElementById("shopButton");
    shopButton.classList.remove('hide');

    const wrapper = document.getElementById('loading');
    if (wrapper) {
        wrapper.remove();
    }


    loadLevel();

    hideLoadingBar();

};

var executed = false;

var init = (function () {
    executed = false;
    return function () {
        if (!executed) {
            executed = true;
            initGame();

        }
    };
})();


init();


function loadLevel() {

    for (let i = 0; i < 20; i++) {

        var gltfLoader = new GLTFLoader().setPath();
        gltfLoader.setDRACOLoader(dracoLoader);
        gltfLoader.load('models/scene' + i + '.glb', function (glb) {
            models.push(glb);
            THREE.Cache.add('obj' + i, glb);
            THREE.Cache.add('mesh' + i, glb.scene);

            if (i == 19) {
                setTorus();

            }
            //models[i]= THREE.Cache.get('scene'+i)

            document.getElementById('level-progress').innerHTML = poppedBubble + " / " + bubbleCount;


        });

    }

    //level = Number(localStorage.getItem("level"));


    loadingManager = THREE.DefaultLoadingManager;
    loadingManager.onStart = function (item, Loaded, Total) {

        //console.log( 'Started loading file: ' + item + '.\nLoaded ' + Loaded + ' of ' + Total + ' files.' );

    };
    loadingManager.onProgress = function (item, loaded, total) {
        //console.log(item, loaded, total);
    };
    loadingManager.onLoad = function (item, loaded, Total) {

        //THREE.Cache.add(item,loaded);
        if (RESOURCES_LOADED === false) {
            RESOURCES_LOADED = true;

        }

    }



    //for(var _key in models){(_key);
    //}

}

function hideLoadingBar() {
    const canvas = document.getElementsByClassName('webgl')[0];
    const shopButton = document.getElementById("shopButton");
    const shop = document.getElementsByClassName('shop')[0];
    const divProgressBar = document.getElementsByClassName('progress-bar')[0];
    canvas.classList.remove('hide');
    shop.classList.add('hide');
    divProgressBar.classList.remove('hide');
    shopButton.classList.remove('hide');
    shopButton.setAttribute("style", "visibility: visible;");
}

function setTorus() {
    var gltfLoader = new GLTFLoader().setPath();
    gltfLoader.setDRACOLoader(dracoLoader);
    gltfLoader.load('models/torus.glb', function (glb) {
        models.torus = glb;
        THREE.Cache.add('torusobj', glb);
        THREE.Cache.add('torusmesh', glb.scene);
        setLevelTimeOut();
    });

}

function setLevelTimeOut() {
    setTimeout(setLevel(), 10000)
};

function setLevel() {


    let popitLevel;
    if (level > totalLevel) {
        popitLevel = parseInt((Math.random() * 19), 10);
    } else {
        popitLevel = level - 1;
    }

    textureType = localStorage.getItem("textureType");
    if (textureType) {
        if (textureType == "color") {
            popitColor = colors[localStorage.getItem("color")];
            popitColor2 = colors[parseInt(Math.random() * 10)];
        } else {
            texture = localStorage.getItem("texture");
            map = new THREE.TextureLoader().load(texture);
            map.wrapS = THREE.RepeatWrapping;
            map.wrapT = THREE.RepeatWrapping;
            map.repeat.x = 2;
            map.repeat.y = 2;
        }
    } else {
        popitColor2 = colors[parseInt(Math.random() * 10)];
    }


    if (level == null) {
        console.log("oho : " + models)

        /*models.scene = {
                obj: THREE.Cache.get("scene0"), 
                mesh: null
            };*/
    }


    else {
        let glbscene = THREE.Cache.get('mesh' + popitLevel)
        glbscene.traverse(function (child) {
            if (child instanceof THREE.Mesh) {


                if (child.name.startsWith("Sphere")) {
                    if (textureType == "color") {
                        if (popitColor === 0x3d0903) {

                            child.material = new THREE.MeshStandardMaterial();
                            child.castShadow = true;
                            child.receiveShadow = true;
                            child.material.roughness = 0.4;
                            child.material.color.set(colors[parseInt(Math.random() * 10)]);

                        } else {
                            child.material = new THREE.MeshStandardMaterial();
                            child.castShadow = true;
                            child.receiveShadow = true;
                            child.material.roughness = 0.4;
                            child.material.color.set(popitColor2);
                        }
                    } else {
                        child.material = new THREE.MeshStandardMaterial();
                        child.castShadow = true;
                        child.receiveShadow = true;
                        child.material.roughness = 0.4;
                        child.material.map = map;
                    }


                    bubbleCount += 1;

                }
                else if (child.name.startsWith("External")) {

                    child.material = new THREE.MeshStandardMaterial();
                    child.castShadow = true;
                    child.receiveShadow = true;
                    child.material.roughness = 0.4;
                    child.material.map = null;
                    child.material.color.set(colors[child.name.substr(child.name.length - 1)]);



                } else if (textureType == "color") {
                    if (popitColor === 0x3d0903) {
                        child.material = new THREE.MeshStandardMaterial();
                        child.castShadow = true;
                        child.receiveShadow = true;
                        child.material.roughness = 0.4;
                        child.material.map = null;
                        child.material.color.set(popitColor);
                    } else {
                        child.material = new THREE.MeshStandardMaterial();
                        child.castShadow = true;
                        child.receiveShadow = true;
                        child.material.roughness = 0.4;
                        child.material.map = null;
                        child.material.color.set(popitColor2);
                    }


                } else if (textureType == null) {
                    child.material = new THREE.MeshStandardMaterial();
                    child.castShadow = true;
                    child.receiveShadow = true;
                    child.material.roughness = 0.4;
                    textureType = "color";
                    child.material.map = null;
                    child.material.color.set(popitColor2);

                } else {

                    child.material = new THREE.MeshStandardMaterial();
                    child.castShadow = true;
                    child.receiveShadow = true;
                    child.material.roughness = 0.4;
                    child.material.map = map;
                }

            }
        });

        let oobj = THREE.Cache.get("obj" + popitLevel)
        let mmesh = THREE.Cache.get("mesh" + popitLevel);

        models.torus = {
            obj: THREE.Cache.get('torusobj'),
            mesh: THREE.Cache.get('torusmesh')
        };

        models[popitLevel].scene = {
            obj: oobj,
            mesh: mmesh
        };



        /* models = {
                scene : {
                    obj: THREE.Cache.get("scene"+popitLevel), 
                    mesh: null
                    },
                torus : {
                    obj:"models/torus.glb",
                    mesh: null
                }
            }; */
        onResourcesLoaded(popitLevel);
    }

}


var objects = [];


function onResourcesLoaded(seviye) {

    meshes["scene"] = models[seviye].scene.mesh.clone();
    //meshes["scene"].material = material;
    meshes["scene"].scale.set(0.06, 0.06, 0.06);
    meshes["scene"].position.set(0, 0.15, 0);
    meshes["scene"].rotation.set(0, Math.PI, 0);
    meshes["scene"].castShadow = true;
    meshes["scene"].receiveShadow = true;
    //meshes["scene"].material.map = map;

    for (let i = 0; i < meshes["scene"].children.length; i++) {



        objects.push(meshes["scene"].children[i]);


    }

    scene.add(meshes["scene"]);
}


window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})


// Mouse

const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) => {
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = - (event.clientY / sizes.height) * 2 - 1
})


// Raycaster

const raycaster = new THREE.Raycaster();

document.addEventListener('mousemove', onDocumentMouseMove)
document.addEventListener('click', onClickToBubble)
document.addEventListener('touchstart', onTouchToBubble)


let mouseX = 0;
let mouseY = 0;

let targetX = 0;
let targetY = 0;

const windowX = window.innerWidth / 2;
const windowY = window.innerHeight / 2;

function onDocumentMouseMove(event) {

    mouseX = (event.clientX - windowX)
    mouseY = (event.clientY - windowY)

}



// Touch pop bubbles

function onTouchToBubble(event) {
    mouse.x = (event.touches[0].clientX / sizes.width) * 2 - 1;
    mouse.y = (event.touches[0].clientY / sizes.height) * -2 + 1;
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(objects, true);

    if (intersects.length > 0) {
        for (let i = 0; i < intersects.length; i++) {
            if (intersects[i].object.name.includes("Sphere")) {
                var tarVector3 = new THREE.Vector3
                SpawnTorus(intersects[i].object.getWorldPosition(tarVector3)) // Create pop effect
                removeEntity(intersects[i].object.name);  // Remove clicked bubble
                poppedBubble += 1; // Add 1 to score
                progressPercentage = (poppedBubble * 100) / bubbleCount; // Caluculate what percentage of the level is completed
                progressPercentageReversed = 100 - (poppedBubble * 100) / bubbleCount;
                const progressBar = document.querySelector('.fillBar'); // Get progress bar element
                const style = getComputedStyle(progressBar);
                progressBar.style.clipPath = "inset(0px " + progressPercentageReversed + "% 0px 0px)"  // Set level progress bar
                document.getElementById('level-progress').innerHTML = poppedBubble + " / " + bubbleCount; // Set level progress text
                // Level Complete all bubbles popped
                if (poppedBubble >= bubbleCount) {
                    levelComplete();
                }
                playSound("popSound" + parseInt(Math.random() * 5));
            }


        }
    }

}

// Mouse pop bubbles

function onClickToBubble(event) {
    mouse.x = (event.clientX / sizes.width) * 2 - 1;
    mouse.y = (event.clientY / sizes.height) * -2 + 1;
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(objects, true);
    if (intersects.length > 0) {
        for (let i = 0; i < intersects.length; i++) {
            if (intersects[i].object.name.includes("Sphere")) {
                var tarVector3 = new THREE.Vector3
                SpawnTorus(intersects[i].object.getWorldPosition(tarVector3)) // Create pop effect
                removeEntity(intersects[i].object.name);  // Remove clicked bubble
                poppedBubble += 1; // Add 1 to score
                progressPercentage = (poppedBubble * 100) / bubbleCount; // Caluculate what percentage of the level is completed
                progressPercentageReversed = 100 - (poppedBubble * 100) / bubbleCount;
                const progressBar = document.querySelector('.fillBar'); // Get progress bar element
                const style = getComputedStyle(progressBar);
                progressBar.style.clipPath = "inset(0px " + progressPercentageReversed + "% 0px 0px)"  // Set level progress bar
                document.getElementById('level-progress').innerHTML = poppedBubble + " / " + bubbleCount; // Set level progress text
                // Level Complete all bubbles popped
                if (poppedBubble >= bubbleCount) {
                    levelComplete();
                }
                playSound("popSound" + parseInt(Math.random() * 5));
            }

        }
    }

}



var meshAngle = 0;
var speed = 0.05;
function levelComplete() {

    levelFinished = true;
    meshAngle = 0;
    speed = 0.05;

    increaseLevel().then(
        (onResolved) => {
            //localStorage.removeItem("level");
            localStorage.setItem("level", level);

            meshes["scene"].rotation.set(Math.PI, Math.PI, Math.PI)
            var start = { angle: meshAngle };
            var end = { angle: meshAngle + 360 };
            new TWEEN.Tween(start)
                .to({

                    y: end

                }, 1250)
                .easing(TWEEN.Easing.Cubic.Out).onUpdate(function update() {
                    speed += 0.01;
                    meshAngle = this.angle;
                    meshes["scene"].rotateOnAxis(new THREE.Vector3(0, 1, 0), speed);
                })
                .start();
            new TWEEN.Tween(meshes["scene"].scale)
                .to({
                    x: 0,
                    y: 0,
                    z: 0
                }, 750).delay(500)
                .easing(TWEEN.Easing.Cubic.Out).onComplete(playConfetti, 1500)
                .start();

        },
        (onRejected) => {
            // Some task on failure
        }
    )

    playSound("swoosh");

}

function increaseLevel() {
    level = Number(level) + 1;
    return Promise.resolve("Success");
    // or
    // return Promise.reject("Failure");
}

function playConfetti() {
    playSound("confetti");
    setTimeout(createGameOverUI, 1000);
    svgContainer.classList.remove('hide');
    svgContainer.classList.remove('hide');
    animItem.play();
    animItem.addEventListener('complete', () => {
        animItem.destroy();

    })
}


function createGameOverUI() {
    playSound("win");
    noThanks.innerHTML = language_noThanks[languageCode];
    progressbar.setAttribute("style", "visibility: hidden;");
    UI.classList.remove('hide2');
    sunBurst.classList.add('rotating')
    shopButton.classList.add('hide');
    perfect.classList.remove('hide');
}

// No thanks button

const tapToContinueButton = document.getElementById('gameover-ui');
tapToContinueButton.addEventListener("click", nextLevel);


function nextLevel() {
    if (levelFinished) {
        playSound("click");
        RESOURCES_LOADED = false;
        coin = parseInt(coin) + 25;
        localStorage.setItem("coin", parseInt(coin));
        const UI = document.getElementById('gameover-ui')
        UI.classList.add('hide2');
        meshes = {};
        loadingManager = null;
        clearThree(scene);
        initGame();
        initGame2();

    }

}



var mouseDown = false,
    mouseXX = 0,
    mouseYY = 0;

function onMouseMove(evt) {
    if (!mouseDown) {
        return;
    }

    evt.preventDefault();

    var deltaX = evt.clientX - mouseXX,
        deltaY = evt.clientY - mouseYY;
    mouseXX = evt.clientX;
    mouseYY = evt.clientY;
    if (!shopOn) {
        rotateScene(deltaX, deltaY);
    }

}

function onTouchMove(evt) {
    if (!mouseDown) {
        return;
    }

    evt.preventDefault();

    var deltaX = evt.touches[0].clientX - mouseXX,
        deltaY = evt.touches[0].clientY - mouseYY;
    mouseXX = evt.touches[0].clientX;
    mouseYY = evt.touches[0].clientY;
    rotateScene(deltaX, deltaY);
}

function onMouseDown(evt) {
    evt.preventDefault();

    mouseDown = true;
    mouseXX = evt.clientX;
    mouseYY = evt.clientY;
}

function onTouchDown(evt) {
    evt.preventDefault();

    mouseDown = true;
    mouseXX = evt.touches[0].clientX;
    mouseYY = evt.touches[0].clientY;
}

function onMouseUp(evt) {
    evt.preventDefault();

    mouseDown = false;
}
var ee = document.body.appendChild(renderer.domElement);
ee.addEventListener('mousemove', function (e) {
    onMouseMove(e);
}, false);
ee.addEventListener('mousedown', function (e) {
    onMouseDown(e);
}, false);
ee.addEventListener('mouseup', function (e) {
    onMouseUp(e);
}, false);

function rotateScene(deltaX, deltaY) {
    if (meshes["scene"]) {
        meshes["scene"].rotation.y += deltaX / 100;
    }

}

ee.addEventListener('touchmove', function (e) {
    onTouchMove(e);
}, false);
ee.addEventListener('touchstart', function (e) {
    onTouchDown(e);
}, false);
ee.addEventListener('touchend', function (e) {
    onMouseUp(e);
}, false);

// Destroy Given Entity

function removeEntity(objectName) {

    var selectedObject = scene.getObjectByName(objectName);
    selectedObject.parent.remove(selectedObject);
    selectedObject.geometry.dispose()
    selectedObject.material.dispose()
    scene.remove(selectedObject)

}

// Create Shockwave Fx

function SpawnTorus(vector3Pos) {


    meshes["torus"] = models.torus.mesh.clone();
    meshes["torus"].scale.set(0.01, 0.01, 0.01);
    meshes["torus"].rotation.set(Math.PI / 2, 0, 0);
    meshes["torus"].position.set(vector3Pos.x, vector3Pos.y, vector3Pos.z);
    meshes["torus"].children[0].castShadow = false;
    meshes["torus"].children[0].receiveShadow = false;
    meshes["torus"].children[0].material = new THREE.MeshStandardMaterial({ color: 0xffffff, emissive: 0xfffff, opacity: 1, transparent: true, roughness: 0.7, metalness: 0 })
    scene.add(meshes["torus"]);

    new TWEEN.Tween(meshes["torus"].children[0].material).to({ opacity: 0 }, 350).easing(TWEEN.Easing.Cubic.Out).start();

    new TWEEN.Tween(meshes["torus"].children[0].scale)
        .to({
            x: meshes["torus"].children[0].scale.x * 15,
            z: meshes["torus"].children[0].scale.z * 15

        }, 350)
        .easing(TWEEN.Easing.Cubic.Out)
        .start()
        .onComplete(() => {
            removeEntity(meshes["torus"].children[0].name)
            renderer.renderLists.dispose();
        })

    new TWEEN.Tween(meshes["scene"].rotation)
        .to({
            x: meshes["scene"].rotation.x - 0.05

        }, 50)
        .chain(
            new TWEEN.Tween(meshes["scene"].rotation)
                .to({
                    x: meshes["scene"].rotation.x + 0.05


                }, 50).onComplete(() => {
                    new TWEEN.Tween(meshes["scene"].rotation)
                        .to({
                            x: 0


                        }, 50)

                        .start()
                })


        )

        .start()





}

document.getElementById("skin1").addEventListener("click", () => shopBoxClicked(1));
document.getElementById("skin2").addEventListener("click", () => shopBoxClicked(2));
document.getElementById("skin3").addEventListener("click", () => shopBoxClicked(3));
document.getElementById("skin4").addEventListener("click", () => shopBoxClicked(4));
document.getElementById("skin5").addEventListener("click", () => shopBoxClicked(5));
document.getElementById("skin6").addEventListener("click", () => shopBoxClicked(6));
document.getElementById("shopButton").addEventListener("click", () => openShop());
document.getElementById("closeButton").addEventListener("click", () => closeShop());


// SHOP



function openShop() {
    playSound("click");
    //initShop();
    shopOn = true;
    const shop = document.getElementsByClassName('shop')[0];
    const canvass = document.getElementsByClassName('webgl')[0];
    const divProgressBar = document.getElementsByClassName('progress-bar')[0];
    const shopButton = document.getElementById("shopButton");
    const shopText = document.getElementById("shopText");
    shopButton.classList.add('hide');
    shop.classList.remove('hide');
    canvass.classList.add('hide');
    divProgressBar.classList.add('hide');
    shopText.innerHTML = language_shops[languageCode];




}

function initShop() {
    localStorage.setItem("1", 1);
    coin = parseInt(localStorage.getItem('coin'));
    if (!coin) {
        coin = 0;
    }
    const coinText = document.getElementById("coinText");
    coinText.innerHTML = coin;

    let skinBox;


    for (let i = 1; i < 7; i++) {
        let skinUnlocked = localStorage.getItem(i);
        if (skinUnlocked) {

            unlockedSkins.push(i);
            document.getElementById("shopBox" + i).classList.add('unGray')

        }
    }

    equippedSkin = localStorage.getItem("equippedSkin");

    if (equippedSkin) {
        for (let i = 1; i < 7; i++) {
            skinBox = document.getElementById("shopBox" + i);
            if (equippedSkin == i) {
                skinBox.classList.add('chosenSkin');
            } else if (unlockedSkins.includes(i)) {
                skinBox.classList.add('unChosenSkin');
            } else {
                skinBox.classList.remove('chosenSkin');
                skinBox.classList.remove('unChosenSkin');
                skinBox.classList.add('notPurchased' + i);

            }

        }


    } else {

        for (let i = 1; i < 7; i++) {
            skinBox = document.getElementById("shopBox" + i);

            if (i == 1) {
                skinBox.classList.add('chosenSkin');
            } else if (unlockedSkins.includes(i)) {
                skinBox.classList.add('unChosenSkin');
            } else {
                skinBox.classList.remove('chosenSkin');
                skinBox.classList.remove('unChosenSkin');
                skinBox.classList.add('notPurchased' + i);

            }



        }

        //skinBox.removeProperty('content');
        //skinBox.classList.add('chosenSkin');

    }


    if (firstStart) {
        openShop();
        closeShopFirst();
        // setTimeout(hideLoadingBar(),2000);
        //hideLoadingBar();

    }


}

function shopBoxClicked(boxNumber) {

    playSound("back");
    const coinText = document.getElementById("coinText");
    coinText.innerHTML = coin;

    const pickedBox = document.getElementById("shopBox" + boxNumber);
    let otherBoxes;
    if (unlockedSkins.includes(boxNumber)) {
        pickedBox.classList.remove('unChosenSkin');
        pickedBox.classList.add('chosenSkin');
        for (let i = 1; i < 7; i++) {
            otherBoxes = document.getElementById("shopBox" + i);
            if (boxNumber != i) {
                otherBoxes.classList.remove('chosenSkin');
                otherBoxes.classList.add('unChosenSkin');
            }
        }
        switch (boxNumber) {
            case 1:
                localStorage.setItem("textureType", "color");
                localStorage.setItem("color", 0);
                localStorage.setItem("equippedSkin", 1);
                loadingManager = null;
                break;
            case 2:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture0.png');
                localStorage.setItem("equippedSkin", 2);
                break;
            case 3:
                localStorage.setItem("textureType", "color");
                localStorage.setItem("color", 1);
                localStorage.setItem("equippedSkin", 3);
                break;
            case 4:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture1.png');
                localStorage.setItem("equippedSkin", 4);
                break;
            case 5:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture2.png');
                localStorage.setItem("equippedSkin", 5);
                break;
            case 6:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture3.png');
                localStorage.setItem("equippedSkin", 6);
                break;
        }


    } else if (coin >= (Math.pow(2, boxNumber) * 25)) {

        for (let i = 1; i < 7; i++) {
            otherBoxes = document.getElementById("shopBox" + i);
            otherBoxes.classList.remove('chosenSkin');
            otherBoxes.classList.add('unChosenSkin');
        }

        pickedBox.classList.remove('unChosenSkin');
        pickedBox.classList.remove('grayOut');
        pickedBox.classList.remove('notPurchased' + boxNumber);
        pickedBox.classList.add('chosenSkin');
        pickedBox.classList.add('unGray');
        unlockedSkins.push(boxNumber);
        localStorage.setItem(String(boxNumber), boxNumber);
        coin -= (Math.pow(2, boxNumber) * 25);
        localStorage.setItem("coin", coin);
        const coinText = document.getElementById("coinText");
        coinText.innerHTML = coin;

        switch (boxNumber) {
            case 1:
                localStorage.setItem("textureType", "color");
                localStorage.setItem("color", 0);
                localStorage.setItem("equippedSkin", 1);
                loadingManager = null;
                break;
            case 2:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture0.png');
                localStorage.setItem("equippedSkin", 2);
                break;
            case 3:
                localStorage.setItem("textureType", "color");
                localStorage.setItem("color", 1);
                localStorage.setItem("equippedSkin", 3);
                break;
            case 4:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture1.png');
                localStorage.setItem("equippedSkin", 4);
                break;
            case 5:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture2.png');
                localStorage.setItem("equippedSkin", 5);
                break;
            case 6:
                localStorage.setItem("textureType", "texture");
                localStorage.setItem("texture", 'textures/texture3.png');
                localStorage.setItem("equippedSkin", 6);
                break;
        }
    }

}


function closeShop() {
    playSound("click");
    shopOn = false;
    const shopButton = document.getElementById("shopButton");
    const shop = document.getElementsByClassName('shop')[0];
    const canvas = document.getElementsByClassName('webgl')[0];
    const divProgressBar = document.getElementsByClassName('progress-bar')[0];

    shop.classList.add('hide');
    canvas.classList.remove('hide');
    divProgressBar.classList.remove('hide');
    shopButton.classList.remove('hide');

    meshes = {};
    models = [];
    loadingManager = null;
    clearThree(scene);
    RESOURCES_LOADED = false;
    //scene.remove.apply(scene, scene.children);
    /*
    for(let j=4; j <= scene.children.length-1; j++){
        for(let i=scene.children[j].children.length-1; i >= 0; i--){
            
                if(scene.children[j].children[i]
                    ){
                    removeEntity(scene.children[j].children[i].name)
                }
                
            
        }
    } 
    */


    //scene.children.forEach(element => checkDestroy(element) )
    scene = null;
    initGame();
    initGame2();
}

function closeShopFirst() {
    shopOn = false;
    const shopButton = document.getElementById("shopButton");
    const shop = document.getElementsByClassName('shop')[0];
    const canvas = document.getElementsByClassName('webgl')[0];
    const divProgressBar = document.getElementsByClassName('progress-bar')[0];


    shop.classList.add('hide');
    canvas.classList.remove('hide');
    divProgressBar.classList.remove('hide');
    shopButton.classList.remove('hide');

}

function clearThree(obj) {
    while (obj.children.length > 0) {
        clearThree(obj.children[0]);
        obj.remove(obj.children[0]);
    }
    if (obj.geometry) obj.geometry.dispose();

    if (obj.material) {
        //in case of map, bumpMap, normalMap, envMap ...
        Object.keys(obj.material).forEach(prop => {
            if (!obj.material[prop])
                return;
            if (obj.material[prop] !== null && typeof obj.material[prop].dispose === 'function')
                obj.material[prop].dispose();
        })
        obj.material.dispose();
    }
}

const clock = new THREE.Clock()

const tick = () => {

    targetX = mouseX * .001
    targetY = mouseY * .001

    // UI Responsive



    // Elapsed Time

    const elapsedTime = clock.getElapsedTime()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
    TWEEN.update()
}

tick()